"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatar = exports.getUserInitials = void 0;
var react_1 = __importDefault(require("react"));
var Avatar_1 = require("./Avatar");
var utils_1 = require("@app/shared/utils");
var constants_1 = require("@server/shared/constants");
var getUserInitials = function (user) {
    return "" + user.firstName[0] + user.lastName[0];
};
exports.getUserInitials = getUserInitials;
var UserAvatar = function (props) {
    return react_1.default.createElement(Avatar_1.Avatar, { text: exports.getUserInitials(props.user), title: "" + utils_1.getUserTitle(props.user) + (props.user.lastName !== constants_1.EXTERNAL_EMAIL ? "\n" + props.user.userEmail : ''), selected: props.selected, onClick: props.onClick, className: props.className }, props.children);
};
exports.UserAvatar = UserAvatar;
